import { createPortal } from 'react-dom';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ToastContainer, Flip } from 'react-toastify';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import 'dayjs/locale/cs';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ro';
import 'dayjs/locale/sk';
import 'dayjs/locale/zh-tw';
import routeObject from './routes';
import CookieConsentBanner from './components/CookieConsentBanner';
import usePreventFileDropNavigation from './hooks/usePreventFileDropNavigation';

const routes = createBrowserRouter(routeObject);

const App = () => {
  usePreventFileDropNavigation();

  return (
    <I18nextProvider i18n={i18next}>
      <RouterProvider router={routes} />
      {window.location.href.startsWith('https://app.swipesign.io') && (
        <>
          <script
            async
            src="https://plausible.io/js/pa-8UJLOz_bTyMqeXIS7cAiU.js"
          ></script>
          <script
            dangerouslySetInnerHTML={{
              __html: `window.plausible=window.plausible||function(){(window.plausible.q=window.plausible.q||[]).push(arguments)},window.plausible.init=window.plausible.init||function(i){window.plausible.o=i||{}};window.plausible.init()`,
            }}
          />
        </>
      )}
      {createPortal(
        <ToastContainer
          position="bottom-right"
          limit={3}
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Flip}
        />,
        document.getElementById('toasts')!
      )}
      {(new URLSearchParams(window.location.search).has('ref') ||
        document.cookie
          .split('; ')
          .some((c) => c.startsWith('cc_cookie='))) && <CookieConsentBanner />}
    </I18nextProvider>
  );
};

export default App;
